import CircularProgress from 'material-ui/CircularProgress';
import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { connect } from 'react-redux';
import { Entities, fetchById, getUpdatedEntity, patch, save } from 'src/common/index';
import ErrorMessage from 'src/components/misc/error-message';
import EngineEditForm from 'src/components/admin/engines/engine-edit-form';

class EngineEditModal extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.state = {
            startedFetching: false,
        };
    }

    componentWillMount() {
        const { isCreate, id } = this.props;

        if (!isCreate) this.props.fetchById(id, Entities.BUS_ENGINE);
        else this.setState({ startedFetching: true });
    }

    componentWillReceiveProps(nextProps) {
        const { engine } = nextProps;

        if (!this.state.startedFetching && engine.isFetching) this.setState({ startedFetching: true });
    }

    callSubmit() {
        return this.childForm.submit();
    }

    didFormChange() {
        return !this.childForm.pristine;
    }

    render() {
        const { engine, isCreate, t } = this.props;

        const finishFetching = this.state.startedFetching && !engine.isFetching;

        if (finishFetching) {
            // check for errors
            if (engine.error) return <ErrorMessage object={engine} />;
            // if everything is ok populate form
            else {
                let initialValues = {};

                // populate form for editing an existing engine
                if (!isCreate && engine.content)
                    initialValues = {
                        id: engine.content.id,
                        name: engine.content.name,
                        rank: engine.content.rank || 0,
                    };

                return (
                    <EngineEditForm
                        initialValues={initialValues}
                        onSubmit={this.handleSubmit}
                        engine={engine.content}
                        t={t}
                        ref={ref => (this.childForm = ref)}
                    />
                );
            }
        } else return <CircularProgress />;
    }

    handleSubmit(data) {
        const { isCreate, handleClose } = this.props;

        if (!isCreate) this.props.patch(data, Entities.BUS_ENGINE);
        else this.props.save(data, Entities.BUS_ENGINE);

        handleClose();
    }
}

const mapStateToProps = state => {
    return {
        engine: getUpdatedEntity(state, Entities.BUS_ENGINE),
    };
};

export default connect(mapStateToProps, { fetchById, patch, save }, null, { withRef: true })(EngineEditModal);
